import React from "react";

// useStyles
import useStyles from "./styles/ListAlamat";

// react-roter-dom
// import { Link } from "react-router-dom";

import { useData } from "../../../components/firebase/DataProvider";
import { Divider, Typography } from "@material-ui/core";

// import { useData } from "../../components";

function ListAlamat({ data, length, handleEdit }) {
  const classes = useStyles();

  const { profil } = useData();

  return (
    <div onClick={handleEdit}>
      <div className={classes.head} style={{ justifyContent: "space-between" }}>
        <Typography className={classes.title}>{data.judul}</Typography>
        <Typography
          // component="span"
          // variant="body2"
          style={{ display: "inline" }}
          // className={classes.inline}
          color="error"
        >
          {"     "} {profil?.alamat_utama === data.id ? "[Utama]" : ""}
        </Typography>
      </div>
      <div className={classes.body}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <p className={classes.bodyTitle}>
              {data.nama_penerima}, {data.no_telepon}
            </p>
            <p className={classes.bodyTitle}>
              {data.provinsi.name}, {data.kota.name}, Kec. {data.kecamatan.name}
              , Kel. {data.kelurahan.name}, {data.alamat_lengkap}
            </p>
          </div>
        </div>
      </div>
      <Divider />
    </div>
  );
}

export default ListAlamat;
